import { ChannelModel } from "../../channel/models/ChannelModel";

export class OrderImportSpecificModel {
	channel: ChannelModel = new ChannelModel();
	idExternalChannel: string = "";

	isValid():boolean {
		return !!this.channel && !!this.idExternalChannel;
	}
}
